import {inject, injectable} from "inversify";
import TeamFieldBasedCurrency from "@/modules/action-points/services/TeamFieldBasedCurrency";
import {GateTypeEnum} from "@/modules/action-points/enums";
import {Bank} from "@/modules/finances/services/Bank";
import {EventEmitter} from "@/modules/base/events";
import {BalanceCurrencyMetaInterface} from "@/modules/action-points/interfaces";

@injectable()
export default class BalanceActionPointsCurrency extends TeamFieldBasedCurrency {
  constructor(
    @inject(EventEmitter) protected em: EventEmitter,
    @inject(Bank) private bank: Bank
  ) {
    super(em);
  }

  protected getFieldName(): 'balance' {
    return 'balance';
  }

  protected getType(): GateTypeEnum {
    return GateTypeEnum.BALANCE;
  }

  async add(value: number, meta?: BalanceCurrencyMetaInterface): Promise<void> {
    const result = super.add(value, meta);

    await this.bank.log({
      category: meta!.category,
      label: meta!.label,
      amount: value,
    });

    return result;
  }

  async forceSubtract(value: number, meta?: BalanceCurrencyMetaInterface): Promise<void> {
    const result = super.forceSubtract(value, meta);

    await this.bank.log({
      category: meta!.category,
      label: meta!.label,
      amount: -value,
    });

    return result;
  }

  async subtract(value: number, meta?: BalanceCurrencyMetaInterface): Promise<void> {
    const result = super.subtract(value, meta);

    await this.bank.log({
      category: meta!.category,
      label: meta!.label,
      amount: -value,
    });

    return result;
  }
}
